export const PROFILE_STORE_EXPENSES = 'LOGIN_STORE_EMAIL';

export const setExpensesAction = ( expenses ) => {

    return {
        type: PROFILE_STORE_EXPENSES,
        payload: expenses
    };

};